export const IS_SCREEN_SHARING_SUPPORTED = typeof navigator.mediaDevices?.getDisplayMedia === 'function';

export const SCREEN_SHARE_TRACK_PREFIX = 'screen';
